import {initializeApp} from 'firebase/app';
import {initializeFirestore} from 'firebase/firestore';
import {deleteObject, getStorage, ref} from "firebase/storage";
import {getAuth, signInWithEmailAndPassword} from 'firebase/auth';

const devConfig = {
    apiKey: "AIzaSyDPaYXx4Ho4rbQjAW2Cu9pERq92nIwAaIs",
    authDomain: "rhr-app-dev.firebaseapp.com",
    projectId: "rhr-app-dev",
    storageBucket: "rhr-app-dev.appspot.com",
    messagingSenderId: "727726979616",
    appId: "1:727726979616:web:dd81966b66ce7dbfd31a45",
    measurementId: "G-ZNE7W15BCV"
};

const prodConfig = {
    apiKey: "AIzaSyDDK5s5L0OdP9t_5vhpl5n8rihqpsAi1P0",
    authDomain: "rhr-app-prod.firebaseapp.com",
    projectId: "rhr-app-prod",
    storageBucket: "rhr-app-prod.appspot.com",
    messagingSenderId: "968519727372",
    appId: "1:968519727372:web:679c27ae592ce790923129",
    measurementId: "G-ML4XFJX2XC"
};

const firebaseConfig = process.env.REACT_APP_ENV === "production" ? prodConfig : devConfig;

const app = initializeApp(firebaseConfig);

const db = initializeFirestore(app, {
    experimentalForceLongPolling: true, // Forces use of long polling instead of WebChannel
    useFetchStreams: false, // Disables new streaming behavior
});

const storage = getStorage()

const auth = getAuth(app)

const newsCollectionName = 'news'

const newsScheduledCollectionName = 'news_scheduled'

const eventsCollectionName = 'events'

const eventTimingResultsCollectionName = 'eventTimingResults'

const reportsCollectionName = 'appReports'

const adminCollectionName = 'admin'

const eventScheduledBadgesCollectionName = 'eventScheduledBadges'

const extractFilePathFromUrl = (url) => {
    const urlParts = url.split('/o/');
    if (urlParts.length < 2) return null;

    const filePath = urlParts[1].split('?')[0];
    return decodeURIComponent(filePath);
};

const deleteFileByUrl = async (url) => {
    const filePath = extractFilePathFromUrl(url);
    console.log('Url: ', filePath)

    const fileRef = ref(storage, filePath);

    try {
        await deleteObject(fileRef);
        console.log(`Файл успешно удален: ${filePath}`);
    } catch (error) {
        console.error(`Ошибка при удалении файла: ${filePath}`, error);
    }
};

const doSignInWithEmailAndPassword = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
};

export {
    db,
    storage,
    auth,
    newsCollectionName,
    newsScheduledCollectionName,
    eventsCollectionName,
    eventTimingResultsCollectionName,
    adminCollectionName,
    reportsCollectionName,
    eventScheduledBadgesCollectionName,
    deleteFileByUrl,
    doSignInWithEmailAndPassword
};
